"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSoftLogicHospiceParser = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class DataSoftLogicHospiceParser {
    constructor() { }
    /**********************************************************************************************************************
     *                     START : DATASOFTLOGIC Software Parser
     * ********************************************************************************************************************/
    /**
     * @function DataSoftLogicSoftwareParser
     * @param pastedData
     * @summary DataSoftLogicSoftwareParser Software Parser @pastedData string break by session to session
     * @returns {callback}
     */
    parse(pastedData, event, callbackEmit) {
        try {
            //**Session 1 Patient name*/
            const sessionFirst = (0, helper_1.substrInBetween)(pastedData, "PATIENT BASIC INFO", "Additional Note:");
            //**Patient Information*/
            const patientInfo = this.gettingPatientDetails(sessionFirst);
            const sessionSix = (0, helper_1.substrInBetween)(pastedData, "Patient Contact Person (Primary):", "EPP Assessment");
            const caregiverInfo = this.getCaregiver(sessionSix);
            const sendCallBackData = Object.assign(Object.assign({}, patientInfo), { info: {
                    careGiver: caregiverInfo,
                } });
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from DataSoftLogic
     */
    gettingPatientDetails(sessionFirst) {
        if (!sessionFirst) {
            return {};
        }
        let Dob = (0, helper_1.substrInBetween)(sessionFirst, "Birth Date:", "Gender:");
        if (Dob) {
            Dob = (0, helper_1.trim)(Dob);
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(sessionFirst)), this.patientPhoneNumberWithAddress(sessionFirst)), { email: (0, helper_1.getEmailAddress)((0, helper_1.substrInBetween)(sessionFirst, "N/A", "N/A")), dob: (0, helper_1.getDOB)(Dob, true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from DataSoftLogic
     */
    getInsurance(sessionThird) {
        const thirdSession = (0, helper_1.trim)(sessionThird);
        if (!thirdSession) {
            return {};
        }
        let insurance = "";
        const insuranceToBreak = thirdSession.split("\n");
        for (let fIndex = insuranceToBreak.length - 1; fIndex > 0; fIndex--) {
            const preIndexValue = (0, helper_1.trim)(insuranceToBreak[fIndex - 1]);
            const currentValue = (0, helper_1.trim)(insuranceToBreak[fIndex]);
            if (preIndexValue == "Primary:" && currentValue) {
                insurance = currentValue;
                //Loop Break
                break;
            }
        }
        //Primary Insurance and Secondary Insurance
        return { insurance };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from DataSoftLogic
     */
    getContactInfo(sessionSix, sessionSeven, sessionEight) {
        const primaryPhy = {
            info: {
                physician: [
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 1,
                    },
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 2,
                    },
                ],
                pharmacy: [this.getPharmacy(sessionEight)],
                careGiver: this.getCaregiver(sessionSix),
            },
        };
        const breakPhysician = sessionSeven.split("Admitting Physician:");
        for (const value of breakPhysician) {
            const phyInfo = this.getPhysicianInfo(value);
            if (!primaryPhy.info.physician[0].name) {
                Object.assign(primaryPhy.info.physician[0], phyInfo);
            }
            else {
                Object.assign(primaryPhy.info.physician[1], phyInfo);
                break;
            }
        }
        //@Return
        return primaryPhy;
    }
    getPhysicianInfo(data) {
        try {
            const phyFullName = data.substr(0, data.indexOf("Address:"));
            const breakName = phyFullName.split(" ");
            let fullName = breakName.join(" ").replace(",", "");
            let firstNumber = "";
            if (breakName.length >= 3) {
                fullName = `${(0, helper_1.trim)(breakName[1])} ${(0, helper_1.trim)(breakName[2])} ${(0, helper_1.trim)(breakName[0]).replace(",", "")}`;
            }
            else if (breakName.length >= 2) {
                fullName = `${(0, helper_1.trim)(breakName[1])} ${(0, helper_1.trim)(breakName[0].replace(",", ""))}`;
            }
            const numbers = (0, helper_1.phoneNumbers)(data);
            if (fullName && numbers) {
                firstNumber = numbers[0].replace(/[\s-()]/g, "");
            }
            //Return data
            return {
                name: (0, helper_1.trim)(fullName),
                phoneNo: (0, helper_1.changeNumberUSFormat)(firstNumber),
            };
        }
        catch (error) {
            return {};
        }
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacyData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        //Blank data Return
        let updatedData = (0, helper_1.trim)(data);
        //Return black data
        if (!updatedData) {
            return pharmacyData;
        }
        //convert to array
        const breakData = data.split("Primary:");
        //Remove Last index
        breakData.pop();
        updatedData = breakData.join("");
        //@Return
        return pharmacyData;
    }
    getCaregiver(data) {
        var _a;
        const [lastName, firstName] = (0, helper_1.substrInBetweenNew)(data, "Name:", "Address")
            .split(",")
            .map(x => x.trim())
            .map(x => (0, helper_1.toTitleCase)(x));
        const relationship = (0, helper_1.toTitleCase)((0, helper_1.substrInBetweenNew)(data, "Relationship:", "Name:").trim());
        const phoneNo = (_a = (0, helper_1.phoneNumbers)(data)) === null || _a === void 0 ? void 0 : _a.map((no) => (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(no.replace(/[\s-()]/g, ""))));
        return lastName && firstName && phoneNo
            ? [
                {
                    name: `${firstName} ${lastName} - ${relationship}`,
                    phoneNo: phoneNo[0],
                    countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                    sortOrder: 1,
                },
            ]
            : [];
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
            },
        };
        //Numbers
        const numbers = (0, helper_1.phoneNumbers)((0, helper_1.substrInBetween)(firstSession, "Phone 1:", "Phone 2")).map((no) => (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(no.replace(/[\s-()]/g, ""))));
        //Set Last number
        if (numbers && (0, helper_1.arrayLength)(numbers)) {
            info.phoneNo = numbers[0];
        }
        //set address
        const addressString = (0, helper_1.substrInBetween)(firstSession, "Home Address:", "Mailing Address:");
        //Set Address
        info.address.placeName = (0, helper_1.trim)(addressString);
        //@Return address or phoneNo
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        let firstSession = "";
        //Value trim
        if (sessionFirst) {
            firstSession = (0, helper_1.trim)(sessionFirst);
        }
        const firstName = (0, helper_1.substrInBetweenNew)(firstSession, "First Name:", "Last Name:");
        const lastName = (0, helper_1.substrInBetweenNew)(firstSession, "Last Name:", "Middle Initial:");
        name.firstName = (0, helper_1.toTitleCase)((0, helper_1.trim)(firstName));
        name.lastName = (0, helper_1.toTitleCase)((0, helper_1.trim)(lastName));
        //@Return name
        return name;
    }
    /**
     * @function getComment
     * @param comment
     * @summary Getting Comment filed from DataSoftLogic
     */
    getComment(comment) {
        if (comment) {
            return { about: comment };
        }
        return { about: "" };
    }
}
exports.DataSoftLogicHospiceParser = DataSoftLogicHospiceParser;
